<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore, useVideobotContentStore, useGlobalStateStore } from '../../../store';
import Submenu from './components/Submenu.vue'
import TextContent from './components/TextContent.vue';

const felixBagAuxStore = useFelixBagAuxStore();
const videobotContent = useVideobotContentStore();
const felixBagGlobalStore = useGlobalStateStore();

const licencaParentaItems = {...videobotContent.videobotContent.licenca_parental_paternidade.licenca_parental_paternidade}

const items = ref([
  {id: 'beneficios', title: 'Benefícios', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/941aedcf-7e4b-4b6b-867b-db29a4784bac.svg'},
  {id: 'programas_bem_estar', title: 'Programas Bem-Estar', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/727bc0cc-8fb7-404e-ba32-89da94fe81a7.svg'},
  {id: 'licenca_maternidade', title: 'Licença Maternidade', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/8dda680d-a630-4bbe-b26a-a252909efe85.svg'},
  {id: 'licenca_parental_paternidade', key:'informacoes_importantes', title: 'Licença Parental Paternidade', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/8dda680d-a630-4bbe-b26a-a252909efe85.svg'},
  {id: 'conteudos_maternidade', title: 'Conteúdos Maternidade', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/8954ee59-5f8a-4c5b-9cf0-5595c98d3f2d.svg'},
  {id: 'conteudos_parentalidade', title: 'Conteúdos Parentalidade', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/11a2bffa-87d7-4cb8-945a-ec01ea8c2c7c.svg'},
  {id: 'e_books', title: 'Ebooks', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/e2d7e189-662b-4c25-8b79-ddab2973f5ef.svg'},
  {id: 'links_uteis', title: 'Links Úteis', img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/e2d7e189-662b-4c25-8b79-ddab2973f5ef.svg'}
])

const showSubmenu = ref(false)
const openText= ref(false)
const submenuId = ref('')

onMounted(() => {
  felixBagAuxStore.pauseAfter(1000)
});

function seeContent() {
  felixBagGlobalStore.setViewContent('licenca_parental_paternidade', 'informacoes_importantes');
}

</script>

<template>
  <div id="trilha-de-cuidado">
    <div class="header">
      <div style="display: flex; flex-direction: column; align-items: start; width: 60%;">
        <v-btn
          @click="felixBagAuxStore.hideInteractive('trilha-de-cuidado');"
          variant="text" color="inherit"><img
            src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
            alt=""></v-btn>
        <p class="submenu-title">Trilha de cuidados</p>
      </div>


      <img style="width: 40%;"
        src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/51990468-49c0-4d27-a166-de69bf5fbb54.svg"
        alt="">

    </div>

    <v-card variant="flat" class="mx-auto" max-width="300" style="margin-top: 5%; overflow: hidden; overflow-y: auto;
    height: 60%">
      <v-list>
        <v-list-item class="jb-save" :data-source="item.id" height="60px" v-for="item in items" :key="item.id" :value="item"
        @click="item.id === 'licenca_parental_paternidade' ? [selectedItem = licencaParentaItems, openText = true, seeContent()] : [showSubmenu = true, submenuId = item]">
          <template v-slot:prepend>
            <div class="icon-wrapper">
              <img style="width: 20px;"
                :src="item.img"
                alt="">
            </div>

            <v-list-item-title style="margin-left: 20px; max-width: 150px; word-wrap: break-word; font-size: 13px;"
              v-text="item.title"></v-list-item-title>
          </template>

          <template v-slot:append>
            <img
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg"
              alt="">
          </template>
        </v-list-item>

      </v-list>
    </v-card>
  </div>

  <TextContent :item="selectedItem" @close-content="openText = false" v-if="openText" :parentalidade="selectedItem"/>
  <Submenu @close-submenu="showSubmenu = false" v-if="showSubmenu" :id="submenuId"></Submenu>
</template>

<style scoped>
#trilha-de-cuidado {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  z-index: 1;
}

.header {
  height: 25%;
  background-color: #BC4AFF;
  display: flex;
}

.submenu-title {
  color: white;
  margin-top: 15px;
  font-size: 20px;
  text-align: start;
  margin-left: 20%;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6E7FF;
  border-radius: 50%;
}
</style>